class FarelistController {
  constructor ($state, $http, $filter, $cookies) {
    this.$http = $http;
    this.$filter = $filter;
    this.$state = $state;
    this.$cookies = $cookies;
    this.data = {};
    this.request = $state.params.request || this.getRequestCookie();
    this.loading = true;

    if (!this.request) {
      this.$state.go('app.home');
    } else {
      this.getFareList();
    }
  }

  getRequestCookie () {
    var request = this.$cookies.get('request');
    if (!request) return null;
    if (request == undefined) return null;

    return JSON.parse(request);
  }

  getFareList () {
    let selfController = this;
    selfController.loading = true;
    return this.$http
      .post('/Ajax.aspx/StepFareList', {
        LocalityID: this.request.Locality.ID,
        wasteTypes: this.request.WasteType.ID,
        dateStart: this.$filter('date')(this.request.pickupdate, 'dd/MM/yyyy'),
        dateEnd: this.$filter('date')(this.request.returndate, 'dd/MM/yyyy'),
        PostCode: this.request.PostCode
      })
      .then(function (response) {
        selfController.loading = false;
        selfController.data.fareList = response.data.data.fareList.records;
      });
  }

  getCategory (fare) {
    if (fare.Category.toUpperCase() == 'SKIPBAG') {
      return 'Skip Bag';
    } else if (fare.Category.toUpperCase() == 'SKIPTRAILER') {
      return 'Mobile Skip';
    }

    return fare.Category;
  }

  selectFare (fare) {
    this.request.fare = fare;
    this.$cookies.put('request', JSON.stringify(this.request));
    this.$state.go('app.delivery', {
      request: this.request
    });
  }
}

FarelistController.$inject = ['$state', '$http', '$filter', '$cookies'];

export { FarelistController };



/** WEBPACK FOOTER **
 ** ./src/app/components/booking/farelist/farelist.controller.js
 **/